import UserRoleIcon from '@material-ui/icons/AssignmentInd';

export default {
  icon: UserRoleIcon,
}